import axios from 'axios';
import { __ } from "../app"
import { apiHost, authHost } from "../config"
import {  fetchResultsByTerm, useFetchResultByUrl } from './helpers/autocomplete-service';

export async function autocomplete( term, { abortController = AbortController } ) {
    var url = apiHost + '/api/admin/reseller/autocomplete';
    return await fetchResultsByTerm( url, term, { abortController } )
}

export function useReseller( resellerId = false, { context = 'autocomplete' } = {} ) {

    var fetchParams = {
        getId: r => r?.id,
        getUrl: r => apiHost + '/api/admin/reseller/' + parseInt( r?.id ),
        initialState: {
            id: resellerId
        }
    } 

    if( context == 'autocomplete' ) {
        fetchParams = {
            getId: r => r?.ownerId,
            getUrl: r => apiHost + '/api/admin/reseller/autocomplete/' + parseInt( r?.ownerId ),
            initialState: {
                resellerIdd: resellerId
            }
        }
    }

    return useFetchResultByUrl( fetchParams );
}


export async function createReseller( resellerModel ) {
    
    try {
        const response = await axios.post( apiHost + '/api/admin/reseller',  { 
            ...resellerModel,
            id: 0
        } );

        return response;
    }
    catch( e ) {
        return {
            error: true,
            message: e?.response?.data
        }
    }
}



export async function updateReseller( resellerModel ) {

    try {
        const response = await axios.put( apiHost + '/api/admin/reseller/' + resellerModel?.id, resellerModel )
        return response;
    }
    catch( e ) {
        return {
            error: true,
            message: e?.response?.data
        }
    }
}